import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  IconButton,
} from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";

const DeliveryLogDialog = ({
  open,
  handleClose,
  editData,
  fetchDeliveries,
}) => {
  const [formData, setFormData] = useState({
    routeId: "",
    shopId: "",
    products: [],
    date: new Date().toISOString().split("T")[0],
  });

  const [routes, setRoutes] = useState([]);
  const [shops, setShops] = useState([]);
  const [products, setProducts] = useState([]);
  const [userId, setUserId] = useState("");
  useEffect(() => {
    if (editData) {
      setFormData({
        routeId: editData.routeId || "",
        shopId: editData.shopId || "",
        date: formData.date || "",
        products:
          editData.items?.map((item) => ({
            productId: item.productId || "",
            deliveryQty: item.deliveryQuantity?.toString() || "0",
            withdrawalQty: item.withdrawalQuantity?.toString() || "0",
          })) || [],
      });
    } else {
      setFormData({
        routeId: "",
        shopId: "",
        products: [],
      });
    }
  }, [editData]);

  useEffect(() => {
    const user = localStorage.getItem("UserId");
    setUserId(user);
    fetchRoutes();
    fetchProducts();
    fetchShops();
  }, []);
  const fetchRoutes = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/routes`);
      if (response.ok) {
        const data = await response.json();
        setRoutes(data);
      }
    } catch (error) {
      console.log("error", error.message);
    }
  };
  const fetchProducts = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/products`);
      if (response.ok) {
        const data = await response.json();
        setProducts(data);
      }
    } catch (error) {
      console.log("error", error.message);
    }
  };
  const fetchShops = async (routeId) => {
    if (!routeId) return;
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/shop/${routeId}`
      );
      if (response.ok) {
        const data = await response.json();
        setShops(data);
      }
    } catch (error) {
      console.log("error", error.message);
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (name === "routeId") {
      fetchShops(value);
    }
  };

  const handleProductChange = (index, field, value) => {
    const updatedProducts = [...formData.products];
    updatedProducts[index][field] = value;
    setFormData((prev) => ({ ...prev, products: updatedProducts }));
  };

  const addProduct = () => {
    setFormData((prev) => ({
      ...prev,
      products: [
        ...prev.products,
        { productId: "", deliveryQty: "", withdrawalQty: "" },
      ],
    }));
  };

  const removeProduct = (index) => {
    const updatedProducts = formData.products.filter((_, i) => i !== index);
    setFormData((prev) => ({ ...prev, products: updatedProducts }));
  };

  const handleSubmit = () => {
    const payload = {
      shopId: formData.shopId,
      driverId: userId,
      date: formData.date,
      routeId: formData.routeId,
      logItems: formData.products.map((product) => ({
        productId: product.productId,
        deliveryQuantity: Number(product.deliveryQty) || 0,
        withdrawalQuantity: Number(product.withdrawalQty) || 0,
      })),
    };

    const url = editData
      ? `${process.env.REACT_APP_API_URL}/updateDeliveryLog/${editData.id}`
      : `${process.env.REACT_APP_API_URL}/delivery-log`;

    const method = editData ? "PUT" : "POST";

    fetch(url, {
      method: method,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Response:", data);
        handleClose();
        fetchDeliveries();
      })
      .catch((error) => console.error("Error:", error));
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>
        {editData ? "Edit Delivery Log" : "Add Delivery Log"}
      </DialogTitle>
      <DialogContent>
        {/* Route Dropdown */}
        <FormControl fullWidth margin="dense">
          <InputLabel>Route</InputLabel>
          <Select
            name="routeId"
            value={formData.routeId}
            onChange={handleChange}
          >
            {routes.map((route) => (
              <MenuItem key={route._id} value={route._id}>
                {route.routeName}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl fullWidth margin="dense">
          <InputLabel>Shop</InputLabel>
          <Select name="shopId" value={formData.shopId} onChange={handleChange}>
            {shops.map((shop) => (
              <MenuItem key={shop._id} value={shop._id}>
                {shop.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <TextField
          label="Delivery Date"
          type="date"
          fullWidth
          margin="dense"
          name="date"
          value={formData.date}
          onChange={handleChange}
          InputLabelProps={{ shrink: true }}
        />
        {formData.products.map((product, index) => (
          <div
            key={index}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              marginTop: "10px",
            }}
          >
            <FormControl fullWidth>
              <InputLabel>Product</InputLabel>
              <Select
                value={product.productId}
                onChange={(e) =>
                  handleProductChange(index, "productId", e.target.value)
                }
              >
                {products.map((prod) => (
                  <MenuItem key={prod._id} value={prod._id}>
                    {prod.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <TextField
              label="Delivery Qty"
              type="number"
              value={product.deliveryQty}
              onChange={(e) =>
                handleProductChange(index, "deliveryQty", e.target.value)
              }
              style={{ width: "100px" }}
            />
            <TextField
              label="Withdrawal Qty"
              type="number"
              value={product.withdrawalQty}
              onChange={(e) =>
                handleProductChange(index, "withdrawalQty", e.target.value)
              }
              style={{ width: "100px" }}
            />

            <IconButton onClick={() => removeProduct(index)} color="error">
              <RemoveCircleIcon />
            </IconButton>
          </div>
        ))}

        <Button
          onClick={addProduct}
          startIcon={<AddCircleIcon />}
          color="primary"
        >
          Add Product
        </Button>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose} color="secondary">
          Cancel
        </Button>
        <Button onClick={handleSubmit} color="primary">
          {editData ? "Update" : "Add"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeliveryLogDialog;
